import React, { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { Input, FormGroup } from 'reactstrap';

const SearchTemplateByName = ({ setName: setSearchName }) => {
  const [name, setName] = useState('');
  const launchSearch = useCallback(
    debounce((n) => setSearchName(n.toLowerCase()), 1000),
    [setSearchName],
  );
  useEffect(() => {
    launchSearch(name);
  }, [name]);

  return (
    <FormGroup style={styles.searchContainer}>
      <Input
        style={styles.searchInput}
        id="templateSearchByName"
        name="templateSearchByName"
        placeholder="Search templates by name"
        type="search"
        value={name}
        onChange={({ target: { value } }) => setName(value)}
      />
    </FormGroup>
  );
};

const styles = {
  searchContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 15,
  },
  searchInput: {
    width: 400,
  },
};

export default SearchTemplateByName;



// WEBPACK FOOTER //
// ./src/components/templates-manager/search-bar/search-template-by-name.js